<template>
  <div class="content">
    <div class="col-md-8 ml-auto mr-auto">
      <h2 class="text-center">{{ $t('ptSchedule.title') }}</h2>
      <p class="text-center">
        {{ $t('ptSchedule.description') }}
      </p>
    </div>
    <div class="row mt-5">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title">{{ $t('ptSchedule.tableTitle') }}</h4>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                class="select-primary mb-3 pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <div class="row">
                <div class="col-6">
                  <base-input>
                    <el-input
                      type="search"
                      class="mb-3 search-input"
                      prefix-icon="el-icon-search"
                      :placeholder="$t('generic.searchInTablePlaceholder')"
                      v-model="searchQuery"
                      aria-controls="datatables"
                    >
                    </el-input>
                  </base-input>
                </div>
              </div>
            </div>

            <el-table v-loading="loading" :data="queriedData" :empty-text="$t('generic.noData')">
              <el-table-column type="expand">
                <template slot-scope="props">
                  <p-t-schedule-details :details="props.row"/>
                </template>
              </el-table-column>
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="$t(column.label)"
                :formatter="column.formatter"
              >
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                {{ $t('generic.tablePaginationSummary', {from: from + 1, to: to, total: total}) }}
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>
  </div
  >
</template>
<script>
import {Option, Select, Table, TableColumn} from 'element-ui';
import {BaseAlert, BasePagination} from 'src/components';
import Fuse from 'fuse.js';
import {mapState} from "vuex";
import PTScheduleDetails from './PTScheduleDetails'

export default {
  name: 'vehicles',
  components: {
    BasePagination,
    BaseAlert,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    PTScheduleDetails
  },
  computed: {
    ...mapState({
      loading: state => state.public_transport.loading,
    }),
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  data() {
    return {
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      propsToSearch: ['id', 'garage_number', 'route', 'time_card', 'trip_code'],
      tableColumns: [
        {
          prop: 'id',
          label: 'ptSchedule.details.id',
        },
        {
          prop: 'garage_number',
          label: 'ptSchedule.details.garage_number',
        },
        {
          prop: 'route',
          label: 'ptSchedule.details.route',
        },
        {
          prop: 'schedule',
          label: 'ptSchedule.details.schedule',
        },
        {
          prop: 'starts_at',
          label: 'ptSchedule.details.starts_at',
          formatter: (row, column, cellValue, index) => {
            return this.$options.filters.time_no_seconds(cellValue)
          },
        },
        {
          prop: 'ends_at',
          label: 'ptSchedule.details.ends_at',
          formatter: (row, column, cellValue, index) => {
            return this.$options.filters.time_no_seconds(cellValue)
          },
        },
        {
          prop: 'time_card',
          label: 'ptSchedule.details.time_card',
        },
        {
          prop: 'operator_id',
          label: 'ptSchedule.details.operator_id',
        },
        {
          prop: 'type',
          label: 'ptSchedule.details.type',
        },
        {
          prop: 'trip_code',
          label: 'ptSchedule.details.trip_code',
        }
      ],
      tableData: [],
      searchedData: [],
      fuseSearch: null
    };
  },
  methods: {},
  mounted() {
    // Loading accounts data
    this.$store.dispatch('GetPTSchedules')
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== '') {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
    "$store.state.public_transport.vehicles"(vehicles) {
      this.tableData = vehicles
      // Fuse search initialization.
      this.fuseSearch = new Fuse(this.tableData, {
        keys: this.propsToSearch,
        threshold: 0.3
      });
    }
  }
};
</script>
<style>
.pagination-select,
.search-input {
  width: 200px;
}
</style>
